
import profileImage from "../../../Images/profileimg.png";
import moment from "moment";
import StarRatings from "react-star-ratings";

const ProfileSectionComponent = ({ data }) => {
    return (
        <div className="editprofileblm ">
            <div className="editprofile">
                {data?.businessProfilePic ? (
                    <img
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                        }}
                        src={data?.businessProfilePic}
                        alt="..."
                    />
                ) : (
                    <img
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                        }}
                        src={profileImage}
                        alt="..."
                    />
                )}

            </div>
            <div className="">
                <h1 className="ocensttxttpppp"> {data?.companyName} </h1>
                <p className="adverttstyusuppp">{data?.TypeOfCompany || data?.companyTypeName}</p>
                <p className="text text-center mt-2 font-size-13">
                    <i className="fa-solid fa-calendar-days mr-2"></i>
                    Joined <strong>{moment(data?.createdOn).format("MMM YYYY")}</strong>
                </p>
            </div>
            <div className="likesfolwoerdivfxls">
                <span className="likstrtxttpp">{data?.businessLikeCount || 0} {data?.businessLikeCount > 1 ? "Likes" : "Like"}</span>
                <span className="likstrtxttpp">{data?.businessFollowCount || 0} {data?.businessFollowCount > 1 ? "Followers" : "Follower"}</span>
            </div>

            <div className="starrating mt-1 d-flex justify-content-center align-items-center">
                {data?.businessStatus && (
                    <>
                        <p className="rating-value" style={{ marginRight: "5px", marginTop: "18px" }}>{data?.PageAvgRating?.toFixed(1) || "0.0"}</p>
                        <StarRatings
                            rating={data?.PageAvgRating}
                            starRatedColor="#F3660B"
                            starEmptyColor="grey"
                            numberOfStars={5}
                            starDimension="20px"
                            starSpacing="1px"
                            className="fa-solid fa-star"
                        />
                    </>
                )
                }
            </div>

        </div>
    );
};
export default ProfileSectionComponent;